module.exports = __webpack_public_path__ + "static/itsm_capabilities_3_3-d710bed8e888a49f1dca47a2bdeb52fa.png";